"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRAVITY_M_S2 = void 0;
exports.GRAVITY_M_S2 = 9.81;
//# sourceMappingURL=constants.js.map